import { createFileRoute } from "@tanstack/react-router";
import Testimonios from "../pages/Testimonios";

export const Route = createFileRoute("/testimonios")({
  component: Testimonios,
});
